import { action } from 'typesafe-actions';

import PageMeta from '@interfaces/page-meta';

import * as types from './types';

export const initApplication = () => action(types.INIT_APPLICATION);

export const fetchSettings = () => action(types.FETCH_SETTING);
export const fetchSettingsSuccess = (data: any) => action(types.FETCH_SETTING_SUCCESS, data);
export const fetchSettingsError = (error: any) => action(types.FETCH_SETTING_ERROR, error);

export const fetchAppMenu = () => action(types.FETCH_APP_MENU);
export const fetchAppMenuSuccess = (data: any) => action(types.FETCH_APP_MENU_SUCCESS, data);
export const fetchAppMenuError = (error: any) => action(types.FETCH_APP_MENU_ERROR, error);

export const fetchCustomPage = (slug: string) => action(types.FETCH_CUSTOM_PAGE, slug);
export const fetchCustomPageSuccess = (data: any) => action(types.FETCH_CUSTOM_PAGE_SUCCESS, data);
export const fetchCustomPageError = (error: any) => action(types.FETCH_CUSTOM_PAGE_ERROR, error);

export const setPageMeta = (data: PageMeta) => action(types.SET_PAGE_META, data);
export const toggleSideNav = (isOpened: boolean) => action(types.TOGGLE_SIDENAV, isOpened);
